<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="validateBeforeSubmit">
      <v-col cols="12">
        <v-text-field
          v-model="vm.firstname"
          label="Name of the Participant"
          v-validate="'required'"
          data-vv-as="nameOfTheParticipant"
          name="nameOfTheParticipant"
          :error-messages="errors.collect('nameOfTheParticipant')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.nDISNumber"
          label="Participant NDIS number"
          v-validate="'required'"
          data-vv-as="nDISNumber"
          name="nDISNumber"
          :error-messages="errors.collect('nDISNumber')"
        ></v-text-field>
      </v-col>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="vm.startDate"
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="vm.startDate"
            label="Start Date"
            readonly
            v-on="on"
            v-validate="'required'"
            data-vv-as="startDate"
            name="startDate"
            :error-messages="errors.collect('startDate')"
          ></v-text-field>
        </template>
        <v-date-picker v-model="vm.startDate" no-title scrollable color="green lighten-1" dark>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(vm.startDate)">OK</v-btn>
        </v-date-picker>
      </v-menu>
      <v-col cols="12"></v-col>
      <h3>How does this agreement fit in with the NDIS?</h3>
      <h4>This agreement is made according to the rules and goals of the National Disability Insurance Scheme(NDIS)</h4>
      <br />
      <v-col cols="12">
        <v-radio-group
          v-model="vm.isPostalTheSame"
          label="A copy of my NDIS plan is attached to this Agreement?"
        >
          <v-radio label="Yes" v-bind:value="true"></v-radio>
          <v-radio label="No" v-bind:value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.serviceArea"
          label="serviceArea"
          required
          v-validate="'required'"
          data-vv-as="serviceArea"
          name="serviceArea"
          :error-messages="errors.collect('serviceArea')"
        ></v-text-field>
      </v-col>

      <!-- <v-flex xs12>
          <v-select
            v-model="vm.serviceArea"
            :items="supportArea"
            label="Service Area"
            data-vv-as="serviceArea"
            name="serviceArea"
            v-validate="'required'"
            :error-messages="errors.collect('serviceArea')"
          ></v-select>
      </v-flex>-->

      <v-col cols="12">
        <v-text-field
          v-model="vm.budget"
          label="Budget"
          required
          v-validate="'required'"
          data-vv-as="budget"
          name="budget"
          :error-messages="errors.collect('budget')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.details"
          label="Details"
          required
          v-validate="'required'"
          data-vv-as="details"
          name="details"
          :error-messages="errors.collect('details')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.supportPaid"
          label="How will the support be paid"
          required
          v-validate="'required'"
          data-vv-as="supportPaid"
          name="supportPaid"
          :error-messages="errors.collect('supportPaid')"
        ></v-text-field>
      </v-col>
      <h3>What is expected of you</h3>
      <h4>
        When you sign the Service Agreement, it means that you agree to do the things that are expected of you. These are called your responsibilities.
        <br />Your responsibilities include things like:
        <br />• Talking to
        <b>ORGANISATION</b> about what supports you would like and how you would like to receive them.
        <br />• Being involved in the selection process of your appointed support staff.
        <br />• Communicating with your support staff about your needs and how they can support you best.
        <br />• Ensuring that when support staff commence, you treat them with respect.
        <br />• Communicate with
        <b>ORGANISATION</b> about any concerns or issues.
        <br />• Advising
        <b>ORGANISATION</b> if you can’t attend. You should always give at least 24 hours notice to avoid having to pay for the cancelled booking.
        <br />• Help to maintain a safe work environment for the staff who work with you.
        <br />• Informing
        <b>ORGANISATION</b> if you want to cease/end your service agreement or you want your NDIS plan reviewed.
      </h4>
      <h3>
        What you can expect of
        <b>ORGANISATION</b>
      </h3>

      <h4>
        <b>Organisation</b> responsibilities include:
        <br />• Ensure you get what you asked for
        <br />• Being open and honest about the work they do
        <br />• Communicate openly and clearly with you in your choosen form
        <br />• Treat you with respect
        <br />• Include you in all decision-making processes
        <br />• Ensuring that your plan is being followed
        <br />• Ensuring that staff are trained and have relevant experience
        <br />• Storing and using your personal information correctly
        <br />• Obeying all the rules and laws that apply.
        <br />This includes:
        <br />o Proving invoices or statements for your supports
        <br />o Checking that the agreement is working well
        <br />We have agreed that the Agreement will be reviewed on (insert date). When we are reviewing the agreement, we will also update the your Risk Assessment profiles and any other supporting documentation as required.
      </h4>
      <br />
      <h3>How to pay for your supports</h3>
      <h4>
        You currently receive funding from NDIS to attend
        <b>ORGANISATION</b> as outlined on page one of this Service Agreement. Any other supports or services outside of this (i.e. workwear, recreational expenses, taxi cost etc.) are to be purchased by yourself as
        <b>ORGANISATION</b> is unable to facilitate this service for you. For additional costs that you choose to purchase through
        <b>ORGANISATION</b> (i.e. attending community events using
        <b>ORGANISATIONM</b> vehicles and Employment)
        <b>ORGANISATION</b> will charge you at current rates. (Provided).
        Our
        <b>ORGANISATION</b> reserves the right to increase costs in line with NDIS recommended charges.
        <br />Some changes will also require review of your plan. This will involve NDIS and a planner to consider updates to your plan.
        <br />
      </h4>
      <br />
      <h3>How to change your Service Agreement</h3>
      <br />
      <h4>
        You can contact to discuss changes that you would like to make to the Agreement. In most cases,
        <b>ORGANISATION</b> will be able to change it. If they cannot make the changes you wish, then we will explain why. If changes are made to the Agreement, we will put these changes in writing and you will need to sign a document saying that you agree to the changes.
      </h4>
      <br />
      <h4>What to do if you have a problem</h4>
      <v-col cols="12">
        <v-text-field
          v-model="vm.contactPerson"
          label="Contact the person"
          required
          v-validate="'required'"
          data-vv-as="contactPerson"
          name="contactPerson"
          :error-messages="errors.collect('contactPerson')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.contactPersonPosition"
          label="Position held"
          required
          v-validate="'required'"
          data-vv-as="contactPersonPosition"
          name="contactPersonPosition"
          :error-messages="errors.collect('contactPersonPosition')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.contactPersonNumber"
          label="Phone number"
          required
          v-validate="'required'"
          data-vv-as="contactPersonNumber"
          name="contactPersonNumber"
          :error-messages="errors.collect('contactPersonNumber')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.contactPersonEmail"
          label="Email"
          required
          v-validate="'required'"
          data-vv-as="contactPersonEmail"
          name="contactPersonEmail"
          :error-messages="errors.collect('contactPersonEmail')"
        ></v-text-field>
      </v-col>
      <h4>If you don't have any success getting your problem fixed, you can contact</h4>
      <v-col cols="12">
        <v-text-field
          v-model="vm.anotherContactName"
          label="Name"
          required
          v-validate="'required'"
          data-vv-as="anotherContactName"
          name="anotherContactName"
          :error-messages="errors.collect('anotherContactName')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.anotherContactPositionHeld"
          label="Position held"
          required
          v-validate="'required'"
          data-vv-as="anotherContactPositionHeld"
          name="anotherContactPositionHeld"
          :error-messages="errors.collect('anotherContactPositionHeld')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.anotherContactPhone"
          label="Phone Number"
          required
          v-validate="'required'"
          data-vv-as="anotherContactPhone"
          name="anotherContactPhone"
          :error-messages="errors.collect('anotherContactPhone')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.anotherContactEmail"
          label="Email"
          required
          v-validate="'required'"
          data-vv-as="anotherContactEmail"
          name="anotherContactEmail"
          :error-messages="errors.collect('anotherContactEmail')"
        ></v-text-field>
      </v-col>
      <h3>How to end a Service Agreement</h3>
      <h4>
        If you want to end the Service Agreement you must tell us. You will need to let us
        <b>know 6 weeks</b> before you wish to end the agreement or as negotiated. This is called a notice period.
        <br />
        <br />At all times, your exit from
        <b>ORGANISATION</b> will be a planned, consultative process. We will discuss your exit with you and/or your advocate.
        <br />Serious breaches of this Agreement may result in immediate ending of this agreement without
        <b>the 6 week</b> notice period or as negotiated. Serious breaches may include but are not limited to:
        <br /> Abusing or assaulting staff or other customers
        <br /> Possessing, trafficking or supplying illicit drugs
        <br /> Using
        <b>ORGANISATION</b> premises for an illegal purpose
        <br /> Continually breaching the terms and conditions of this agreement
        <br /> Damaging or misusing
        <b>ORGANISATION</b> property
        <br /> Tacking action which is intended or would reasonably be expected to lead to unwanted or unfavourable publicity to
        <b>ORGANISATION</b>.
        <br />
        <br />My Service Agreement will end straight away:
        <br /> If I run out of NDIS funding before the end date of this Agreement
        <br /> If I stop being a participant of the NDIS
        <br /> If my NDIS Plan is updated or I get a new plan
        <br /> I end the service before the end of my Service Agreement.
        <br />
      </h4>

      <h3>Goods and Service Tax (GST)</h3>
      <h4>
        The service you receive from
        <b>ORGANISATION</b> will not include GST. It is
        <b>ORGANISATION</b>’s responsibility to check whether GST will apply to the service you receive
        By signing the Agreement,
        <b>ORGANISATION</b> says that they have checked whether GST applies for any additional services or supports you choose to purchase from
        <b>ORGANISATION</b>. GST will be included in the cost.
      </h4>
      <h4>Participant contact details</h4>
      <v-col cols="12">
        <v-text-field
          v-model="vm.participantDaytimePhone"
          label="Your daytime phone number"
          required
          v-validate="'required'"
          data-vv-as="participantDaytimePhone"
          name="participantDaytimePhone"
          :error-messages="errors.collect('participantDaytimePhone')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.participantEveningPhone"
          label="Your evening phone number"
          required
          v-validate="'required'"
          data-vv-as="participantEveningPhone"
          name="participantEveningPhone"
          :error-messages="errors.collect('participantEveningPhone')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.mobileNumber"
          label="Your mobile number"
          required
          v-validate="'required'"
          data-vv-as="mobileNumber"
          name="mobileNumber"
          :error-messages="errors.collect('mobileNumber')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.email"
          label="Email"
          required
          v-validate="'required'"
          data-vv-as="email"
          name="email"
          :error-messages="errors.collect('email')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.participantaddress"
          label="Your home address"
          required
          v-validate="'required'"
          data-vv-as="participantaddress"
          name="participantaddress"
          :error-messages="errors.collect('participantaddress')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.participantAnotherContactName"
          label="The name of someone we can contact if we can't get in touch with you"
          required
          v-validate="'required'"
          data-vv-as="participantAnotherContactName"
          name="participantAnotherContactName"
          :error-messages="errors.collect('participantAnotherContactName')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.participantanotherContactPhone"
          label="Phone number"
          required
          v-validate="'required'"
          data-vv-as="participantanotherContactPhone"
          name="participantanotherContactPhone"
          :error-messages="errors.collect('participantanotherContactPhone')"
        ></v-text-field>
      </v-col>

      <h4>
        <b>Organisation's</b> contact details
      </h4>
      <v-col cols="12">
        <v-text-field
          v-model="vm.organisationPhoneNumber"
          label="Organisation phone number"
          required
          v-validate="'required'"
          data-vv-as="organisationPhoneNumber"
          name="organisationPhoneNumber"
          :error-messages="errors.collect('organisationPhoneNumber')"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.organisationMobileNumber"
          label="Organisation mobile number"
          required
          v-validate="'required'"
          data-vv-as="organisationMobileNumber"
          name="organisationMobileNumber"
          :error-messages="errors.collect('organisationMobileNumber')"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.organisationEmail"
          label="Email Address"
          required
          v-validate="'required'"
          data-vv-as="organisationEmail"
          name="organisationEmail"
          :error-messages="errors.collect('organisationEmail')"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.organisationAddress"
          label="Business Address"
          required
          v-validate="'required'"
          data-vv-as="organisationAddress"
          name="organisationAddress"
          :error-messages="errors.collect('organisationAddress')"
          filled
        ></v-text-field>
      </v-col>
      <h4>By signing this agreement, you agree to all information included</h4>
      <v-col cols="12">
        <v-text-field
          v-model="vm.signingParticipantName"
          label="Participant name"
          required
          v-validate="'required'"
          data-vv-as="signingParticipantName"
          name="signingParticipantName"
          :error-messages="errors.collect('signingParticipantName')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.signingParticipantSign"
          label="Signature"
          required
          v-validate="'required'"
          data-vv-as="signingParticipantSign"
          name="signingParticipantSign"
          :error-messages="errors.collect('signingParticipantSign')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.signingParticipantDate"
          label="Date"
          required
          v-validate="'required'"
          data-vv-as="signingParticipantDate"
          name="signingParticipantDate"
          :error-messages="errors.collect('signingParticipantDate')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.witnessDate"
          label="Witness Name"
          required
          v-validate="'required'"
          data-vv-as="witnessDate"
          name="witnessDate"
          :error-messages="errors.collect('witnessDate')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.witnessSignature"
          label="Witness signature"
          required
          v-validate="'required'"
          data-vv-as="witnessSignature"
          name="witnessSignature"
          :error-messages="errors.collect('witnessSignature')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.participantDate"
          label="Date"
          required
          v-validate="'required'"
          data-vv-as="participantDate"
          name="participantDate"
          :error-messages="errors.collect('participantDate')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.serviceProvider"
          label="Service Provider"
          required
          v-validate="'required'"
          data-vv-as="serviceProvider"
          name="serviceProvider"
          :error-messages="errors.collect('serviceProvider')"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.serviceRepresentative"
          label="Service Provider Representative"
          required
          v-validate="'required'"
          data-vv-as="serviceRepresentative"
          name="serviceRepresentative"
          :error-messages="errors.collect('serviceRepresentative')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.serviceSignature"
          label="Signature"
          required
          v-validate="'required'"
          data-vv-as="serviceSignature"
          name="serviceSignature"
          :error-messages="errors.collect('serviceSignature')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="vm.serivceProviderDate"
          label="Date"
          required
          v-validate="'required'"
          data-vv-as="serivceProviderDate"
          name="serivceProviderDate"
          :error-messages="errors.collect('serivceProviderDate')"
        ></v-text-field>
      </v-col>
      <h4>The participant and Service Provider agree thata this agreement is inline with the main ideas at the NDIS. These ideas include things like having more choices achieving your goals and taking part in the community</h4>

      <v-col cols="12">
        <v-radio-group v-model="vm.isPostalTheSame" label="Checklist for Service Agreement">
          <v-radio label="I know who is making the Agreement" v-bind:value="true"></v-radio>
          <v-radio label="I know what supports to include" v-bind:value="false"></v-radio>
          <v-radio label="I know what is expected of me" v-bind:value="true"></v-radio>
          <v-radio label="I know what is expected of my organisation" v-bind:value="false"></v-radio>
          <v-radio label="I know how the supports will be paid for" v-bind:value="true"></v-radio>
          <v-radio label="I know what to do if I want to make changes" v-bind:value="false"></v-radio>
          <v-radio label="I know what to do if I want to end the agreement" v-bind:value="true"></v-radio>
          <v-radio
            label="I know what to do if I have a problem and I know who to contact"
            v-bind:value="false"
          ></v-radio>
          <v-radio
            label="I have written my service agreement, or I have worked with my provider to write the agreement"
            v-bind:value="true"
          ></v-radio>
          <v-radio
            label="I have attached my Person-Centerd Plan to the agreement if I want to"
            v-bind:value="false"
          ></v-radio>
          <v-radio label="I have a copy of the agreement of my records" v-bind:value="true"></v-radio>
          <v-radio label="I have attached a copy of my NDIS plan" v-bind:value="false"></v-radio>
        </v-radio-group>
      </v-col>

      <v-btn color="primary" type="submit">Continue</v-btn>
    </v-form>
  </v-container>
</template>


<script>
var Models = require("./models.js");
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "service-agreement-form",
  data: () => ({
    e1: 0,
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    vm: {},
    form: {},
    valid: true,

    supportArea: [
      "Support connenction",
      "Coordination of supports",
      "Assistance with accomodation and tenancy obligations ",
      "Life transition planning incliuding mentoring, peer support and individual skill development",
      "Assistance with decision making daily planning and budgeting"
    ],

    checkbox: false
  }),
  props: {
    msg: String
  },
  mounted() {
    this.init();
  },
  computed: {
    currentCase() {
      return this.$store.getters.currentCase;
    }
  },
  methods: {
    init() {
      this.vm =
        this.$store.getters.currentCase == undefined ||
        this.$store.getters.currentCase.participantDetails == undefined
          ? new Models.ParticipantDetails()
          : this.$store.getters.currentCase.participantDetails;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    addParticipantDetails() {
      this.currentCase.participantDetails = this.vm;
      this.$store.dispatch("setCurrentCase", this.currentCase);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.vm.type = "about-me";
          this.currentCase.participantDetails = this.vm;
          this.$store.dispatch("setCurrentCase", this.currentCase);
          this.$store.dispatch("setToast", {
            message: "Form errors please correct before continuing",
            color: "red darken-4"
          });
          return;
        } else {
          this.$store.dispatch("setToast", {
            message: "Form errors please correct before continuing",
            color: "red darken-4"
          });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

